/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Portal - Company Profile View
 */
import React from 'react';
import { Switch, Route, matchPath } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from 'stores/RootStore';

// Design System
import { makeStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CircularProgress from '@material-ui/core/CircularProgress';

import TabPanel from 'components/UserProfile/TabPanel';
import TabLabel from 'components/UserProfile/TabLabel';
import Profile from 'components/UserProfile/Profile';

const tabRouter = {
  0: {
    tabIndex: 0,
    match: '/profile',
    route: 'profile',
  },
};

const UserProfile = props => {
  const classes = styles();
  const stores = useStores();
  const { isLoading } = stores.userStore;
  const [value, setTab] = React.useState(0);

  const handleChange = (event, tab) => {
    event.preventDefault();
    props.history.push(tabRouter[tab].route);
  };

  const routeToTab = () => {
    Object.keys(tabRouter).forEach(key => {
      const match = matchPath(props.location.pathname, {
        path: tabRouter[key].match,
        exact: true,
        strict: false,
      });

      if (match) {
        if (value !== tabRouter[key].tabIndex) {
          setTab(tabRouter[key].tabIndex);
        }
      }
    });
  };

  // Set page title
  stores.appStore.setPage('My');

  // Set tab based on route
  routeToTab();

  return (
    <div className={classes.root}>
      <Tabs
        orientation={isWidthUp('sm', props.width) ? 'vertical' : 'horizontal'}
        indicatorColor='primary'
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        <Tab label={<TabLabel label='Profile' variant='inherit' />} className={classes.tab} />
      </Tabs>
      <Switch>
        <Route path='/profile'>
          <TabPanel title='My Profile' value={value} index={0} className={classes.tabPanel}>
            {isLoading ? <CircularProgress size={40} className={classes.circularProgress} /> : <Profile {...props} />}
          </TabPanel>
        </Route>
      </Switch>
    </div>
  );
};

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
      display: 'flex',
      minHeight: '400px',
      height: '100%',
    },
  },
  tabs: {
    minHeight: '100%',
    minWidth: '120px',
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingTop: '15px',
    [theme.breakpoints.down('xs')]: {
      borderRight: '0px',
    },
  },
  tab: {},
}));

export default withWidth()(observer(UserProfile));
